import { TechProps } from '../types/portfolio';
import { kebabCase } from '../scripts/string-manipulators';
import CC from '../scripts/combine-classes';
import classes from '../styles/portfolio.module.css';

type KnowledgeProps = {
  keyId: string,
  tech: TechProps,
}

const KnowledgeItem = ({
  keyId,
  tech,
}: KnowledgeProps) => {
  return (
    <div
      key={kebabCase(`${keyId}-${tech.text}`)}
      className={CC(
        classes.icon,
        classes[`icon${tech.focus}`],
      )}
      title={tech.title}
    >
      {tech.text}
    </div>
  );
};

export default KnowledgeItem;
